import styled from 'styled-components'

export const CollectionsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding-top: 20px;
  background-color: transparent;
`

export const TableWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Inter', sans-serif;
`

export const Th = styled.th`
  position: sticky;
  top: 0;
  background-color: #f4f4f4;
  z-index: 10;
  text-align: left;
  padding: 18px;
  font-size: 13px;
  font-weight: 500;
  color: #8d8d8d;
  border-bottom: 1px solid transparent;
  white-space: nowrap;
  cursor: default;
`

export const TableRow = styled.tr`
  background-color: #ffffff;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9f9f9;
  }
`

export const Td = styled.td`
  padding: 18px;
  font-size: 15px;
  color: #303030;
  background-color: #ffffff;
  border-bottom: 1px solid #f4f4f4;
  vertical-align: middle;
  white-space: nowrap;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: 4px;

  
  &:hover {
    background-color: transparent;
  }

  img {
    width: 20px;
    height: 20px;
    transition: filter 0.2s ease;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #0090D3;
    transition: filter 0.2s ease, color 0.2s ease;
  }

  
  &.view:hover img,
  &.edit:hover img,
  &.view:hover svg,
  &.edit:hover svg {
    filter: brightness(0.6);
  }

  
  &.delete:hover img,
  &.delete:hover svg {
    filter: brightness(0.6) sepia(1) saturate(5) hue-rotate(-10deg);
  }
`

export const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 18px;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`